import { useAppDispatch } from "../../../../../../app/redux/hooks";
import {
  deleteAddressAsync,
  getAddressListAsync,
} from "../../../../../../app/slices/addressSlice/ProfileSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import CustomButton from "../../../../../components/custom/button";
import { useMediaQuery } from "@mui/material";

export const DeleteAddress = ({ type, modalClose, addressId }: any) => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width:600px)");
  
  const deleteAddres = () => {
    dispatch(deleteAddressAsync(addressId))
      .then((response: any) => {
        if (response?.payload?.status === 200) {
          dispatch(
            showSnackbar({
              message: "Address deleted successfuly.",
              severity: "success",
              autoHide: 2000,
            })
          );
          dispatch(getAddressListAsync());
          modalClose();
        } else {
          dispatch(
            showSnackbar({
              message: "Something went wrong, Please try again later.",
              severity: "error",
              autoHide: 2000,
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: "Something went wrong, Please try again later.",
            severity: "error",
            autoHide: 2000,
          })
        );
      });
  };
  return (
     <>
      <div
      style={{
        // padding: "1.5rem 1.25rem 1.25rem",
        textAlign: "center",
        color: "#1f2937",
      }}
    >
      <p
        style={{
          margin: 0,
          padding: 0,
          fontSize: "1rem",
          lineHeight: 1.75,
          color: "#334155",
          textAlign:"left"
        }}>
            {`Are you sure want to delete this `}
            <span style={{ fontWeight: "bold", color: "#ff0000" }}>{type}</span>
            {` address?`}
            </p>
          <div
        style={{
          margin: "1.25rem 0 0",
          borderBottom: "1px solid #e2e8f0",
        }}
      />
   <div
  className="d-flex justify-content-center"
  style={{
    display: "flex",
    justifyContent: "center",
    gap: isMobile ? "0.5rem" : "0.75rem",
    marginTop: "1.25rem",
    flexWrap: "nowrap",
  }}
>
  <CustomButton
    name="Cancel"
    onClick={modalClose}
    color="secondary"
    variant="outlined"
    fullWidth={false}
    style={{
      minWidth: isMobile ? 130 : 110,
      padding: "0.5rem 1rem",
    }}
  />
  <CustomButton
    name="Yes"
    onClick={deleteAddres}
    fullWidth={false}
    style={{
      minWidth: isMobile ? 140 : 120,
      padding: "0.5rem 1.1rem",
    }}
  />
</div>
    </div>
    </>
  );
}